import { API_BASE } from "@/config/links";

export function recordView(kind, sourceKey) {
  if (!sourceKey || typeof window === "undefined") return;
  const storageKey = `viewed:${kind}:${sourceKey}`;
  try {
    if (window.localStorage.getItem(storageKey)) return;
    window.localStorage.setItem(storageKey, "1");
  } catch {
    // localStorage недоступен (приватный режим и т.п.) — считаем просмотр без дедупликации
  }
  fetch(`${API_BASE}/api/${kind}/${encodeURIComponent(sourceKey)}/view`, { method: "POST", keepalive: true }).catch(() => {});
}
